import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme/theme.component';
import { LayoutModule } from './theme/layouts/layout.module';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ScriptLoaderService } from "./_services/script-loader.service";

import { ClubsService } from "./_services/association/clubs-service";
import { StaffService } from "./_services/association/staff-service";
import { AthleteService } from "./_services/athlete-service";
import { TeamService } from "./_services/team-service";
import { ParentService } from "./_services/parent-service";

import { ThemeRoutingModule } from "./theme/theme-routing.module";
import { AuthModule } from "./auth/auth.module";

// Import PdfJsViewerModule module
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';



@NgModule({
    declarations: [
        ThemeComponent,
        AppComponent,
    ],
    imports: [
        LayoutModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ThemeRoutingModule,
        AuthModule,
        PdfJsViewerModule
    ],
    providers: [ScriptLoaderService, ClubsService, StaffService, AthleteService, TeamService, ParentService],
    bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts